import React, { useContext, useRef } from 'react';
import PbxContext from '../../context/PbxContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import ChartDataLabels from 'chartjs-plugin-datalabels';

const ChartsSent = ({ getRows }) => {
  const getItensStateGlobal = useContext(PbxContext);

  const { storageDataReport } = getItensStateGlobal;
  let { endpointsSendeds } = storageDataReport;
  
  const chartCallsSendedRef = useRef(null);
  
  const getDataToRequestFilter = (event) => {
    if (chartCallsSendedRef.current) {
    const chart = ChartJS.getChart(chartCallsSendedRef.current);
    const clickedElements = chart.getElementsAtEventForMode(event, 'nearest',{ intersect: true }, true);
    if (clickedElements.length > 0) {
      const firstElement = clickedElements[0];
      let labelType = chart.data.datasets[firstElement.datasetIndex].label;
      const labelIndexClicked = chart.data.labels[firstElement.index];
      
      const getIdEndpointClicked = Object.keys(endpointsSendeds).filter((element) => {
        if (endpointsSendeds[element].name === labelIndexClicked) return element;
      });

      labelType === 'Não Atendidas' ? labelType = 'perdida' : labelType = 'atendida';
      getRows('endpoints-sendeds', getIdEndpointClicked.toString(), labelType);
    }
   }
  };

  // const labels = Object.keys(endpointsSendeds);
  const renamedEndpoints = Object.keys(endpointsSendeds).reduce((acc, cur) => {
    acc[`${endpointsSendeds[cur].name}`] = { atendidas: endpointsSendeds[cur].atendidas, perdidas: endpointsSendeds[cur].perdidas };
    return acc;
  }, {});

  const labels = Object.keys(renamedEndpoints);
  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Atendidas',
        // data: labels.map((label) => endpointsSendeds[label].atendidas),
        data: labels.map((label) => renamedEndpoints[label].atendidas),
        backgroundColor: 'rgba(0, 179, 60, 0.7)',
        borderColor: 'rgb(0, 179, 60, 0.5))',
        datalabels: {
          align: 'top'
        },
      },
      {
        label: 'Não Atendidas',
        // data: labels.map((label) => endpointsSendeds[label].perdidas),
        data: labels.map((label) => renamedEndpoints[label].perdidas),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        datalabels: {
          align: 'top'
        },
      },
    ],
  };
  
  return (
    <div className="column column is-half">
      <h2 className="has-text-centered is-size-5">Chamadas Realizadas por Ramal</h2>
        <Bar options={options} data={data} plugins={[ChartDataLabels]} ref={chartCallsSendedRef} getElementAtEvent={(_, event) => getDataToRequestFilter(event)} />
    </div>
  );
}

export default ChartsSent;
